/**
 * Enregistrement du service worker PWA PROXIreduc-28
 * + capture globale de l'invite d'installation (beforeinstallprompt).
 * Appelé depuis index.js.
 */
export function registerPWA() {
  if (typeof window === "undefined") return;

  // Capture précoce de l'invite d'installation pour « Mon Agent IA »
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__deferredInstall = e;
    window.dispatchEvent(new Event("bip-ready"));
  });

  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(() => { /* silent fail — pas critique */ });
  });
}
